import * as React from 'react';
import Button from '@mui/material/Button';
import {useForm} from './FormProvider';

import Spinner from '../Spinner';
import Row from '../Row';


export default function FormButton({children,working = false, onSubmit,...props}) {
    const {handleSubmit} = useForm();

    const propsFunc = (onSubmit) ? handleSubmit(onSubmit) : null;

    return (
        <Row>
            <Button
                type="submit"
                variant="contained"
                fullWidth
                disabled={working}
                onClick={propsFunc}
                {...props}
            >{children}{working && <Spinner size={20} sx={{ml: 1}} />}</Button>
        </Row>
    );
};